import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Language } from '@shared/constants/language';
import { LocalStorageKeys } from '@shared/constants/local-storage-keys';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslationService {
  private http = inject(HttpClient);
  private translate = inject(TranslateService);

  loadingTranslations = signal<boolean>(false);

  setTranslation(lang: Language): Observable<boolean> {
    this.loadingTranslations.set(true);

    return this.downloadTranslation(lang).pipe(
      switchMap((translations) => {
        this.setNewLanguage(translations, lang);

        return of(true);
      })
    );
  }

  downloadTranslation(lang = 'no'): Observable<TranslationItem[]> {
    return this.http.get<TranslationItem[]>(
      'https://translation-api.devinco.com/translate/14/' + lang
    );
  }

  private setNewLanguage(translations: TranslationItem[], lang: Language): void {
    // Build translation object
    const langObj: { [key: string]: string } = {};
    translations.forEach((item) => (langObj[item.key] = item.value));
    // Use translation
    this.translate.setTranslation(lang, langObj);
    this.translate.use(lang);
    localStorage.setItem(LocalStorageKeys.LastSelectedLanguage, lang);
    this.loadingTranslations.set(false);
    document.documentElement.lang = lang.toLowerCase();
  }
}

export interface TranslationItem {
  key: string;
  textId: number;
  value: string;
}
